import type { CabinBaggageTripSummary } from '@eti/schema-types';
import { CabinBaggageStatus } from '@eti/schema-types';
import { getIncludedBaggageText } from './getIncludedBaggageText';

const isCabinBaggageIncluded = (
  cabinBaggageTripSummary: CabinBaggageTripSummary,
  t: (key: any, ...params: any[]) => string,
) => {
  if (
    cabinBaggageTripSummary?.cabinBaggageTravelerDetails[0]?.cabinBaggageStatus !==
    CabinBaggageStatus.IncludedCabinBaggage
  ) {
    return false;
  }
  const cabinBaggageName =
    cabinBaggageTripSummary.cabinBaggageTravelerDetails[0] &&
    getIncludedBaggageText(
      cabinBaggageTripSummary.cabinBaggageTravelerDetails[0].cabinBaggageDetails!,
      'IbeClient.CabinBaggageIncluded.Label',
      t,
    );
  if (!cabinBaggageName) {
    return false;
  }
  return true;
};

export default isCabinBaggageIncluded;
